module.exports = __webpack_public_path__ + "img/ZohoBooks.1ed9ef6e.svg";